import React, { useEffect, useRef,useState } from 'react';
import pictoClose from "../assets/images/close.svg";
import {urlDirectus} from "../Map/config/globals";

export const PopupMatiere = ({closePopupMatiere,listeMatiereCourante , setMatiereCouranteandShow}) => {
    return (
        <div id="infos-matiere" className="mini-popup-carte popup-materiaux rounded-3 p-4 bg-white shadow position-absolute z-5">
            <div className="d-flex flex-column position-relative w-100">
                <div className="mini-popup-carte-picto rounded-3 ratio-11 d-none d-md-flex align-items-center justify-content-center position-absolute start-0"></div>
                <div className="w-100 d-flex align-items-start justify-content-start pb-3">
                    <div className="dotted-pattern dotted-pattern-simple flex-shrink-0"></div>
                    <div className="d-flex flex-column justify-content-center text-start lh-xs px-3">
                        <span className="fw-b fs-5 pb-1"  id="titre-matiere">Forêt</span>
                        <i className="text-spectral"  id="stitre-matiere">Forêt fermée de chênes</i>
                    </div>
                    <button className="toggle-btn ms-auto" onClick={closePopupMatiere}>
                        <img src={pictoClose} />
                    </button>
                </div>

                <div className="w-100 d-flex flex-column align-items-start pb-4">
                    <div className="table-popup w-100 d-flex flex-column align-items-start">
                        <div className="table-popup-onglet active text-uppercase fw-b fs-7 lh-lg px-2 rounded-top">Informations</div>
                        <div className="table-popup-datas fs-7 px-2 py-1 w-100 rounded-3">
                            <div className="table-popup-row d-flex justify-content-between align-items-center border-bottom pb-1">
                                <span>Superficie</span><span className="text-muted text-spectral" id="superficie-matiere">13200m²</span>
                            </div>
                            <div className="table-popup-row d-flex justify-content-between align-items-center pt-1">
                                <span>Détail</span><span className="text-muted text-spectral" id="detail-matiere">Bois 1, bois 2</span>
                            </div>
                        </div>
                    </div>
                    <i className="fs-9 text-muted text-spectral ms-auto pt-2">Sources : ENSAM</i>
                </div>
                <div className="w-100 d-flex align-items-center">
                    <span className="text-uppercase fw-b fs-8 lh-lg">Matières liées</span>
                    <div className="dotted-pattern dotted-pattern-simple dotted-pattern-row opacity-25 flex-grow-1"></div>
                </div>
                <div className="row align-items-stretch justify-content-start">
                {(() => {
                    if (listeMatiereCourante.length > 0) {
                        return (
                            <>
                                {
                                    listeMatiereCourante.map((matiere, index) => {
                                            return(
                                                <div className="col-4 pt-2" key={"matiereliste-"+matiere.id} onClick={()=>setMatiereCouranteandShow(matiere)}>
                                                    <div className="vignette-matiere overflow-hidden p-1 ratio-11 w-100 fs-7 lh-sm rounded-3 d-flex align-items-center justify-content-center position-relative text-center bg-biosources text-white">
                                                        <span class="position-relative z-1">{matiere.libelle + " "}</span>
                                                        {matiere.photo && <img className="w-100 h-100 object-fit-cover z-0 position-absolute" src={urlDirectus + 'assets/'+matiere.photo.id} />}
                                                        </div>
                                                </div>
                                            )
                                    })
                                }
                            </>
                        )
                    }


                })()}
                </div>
            </div>
        </div>
    )
}